import React from 'react'

const Cateringregisteterd = () => {
    return (
        <div>

        </div>
    )
}

export default Cateringregisteterd
